import "./CancellationPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PoliciesDeterminedByAccommodations from "./sections/PoliciesDeterminedByAccommodations";
import Disclaimer from "./sections/Disclaimer";
import ResponsibilityOfTheVisitor from "./sections/ResponsibilityOfTheVisitor";
import CancellationProcess from "./sections/CancellationProcess";
import Footer from "@/reusable_sections/Footer";
export default function CancellationPolicyPage() {
  return <div>
      <Header />
      <PoliciesDeterminedByAccommodations />
      <Disclaimer />
      <ResponsibilityOfTheVisitor />
      <CancellationProcess />
      <Footer />
    </div>;
}